import { I18nKeyType } from "@/i18n";

import {
  DriverFlowBottomButtonPropsType,
  DriverTaskOptionsSelector,
  DriverTaskOptionsSelectorPropsType,
} from "../blocks";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverStepScreenWrapper } from "./DriverStepScreenWrapper";

type DriverScreenWithOptionsPropsType<T> = JobServiceTaskBaseType & {
  title: I18nKeyType;
  bottomButtonProps: DriverFlowBottomButtonPropsType;
  optionsSelectorProps: DriverTaskOptionsSelectorPropsType<T>;
};

const DriverScreenWithOptions = <T,>({
  title,
  jobId,
  serviceId,
  taskId,
  bottomButtonProps,
  optionsSelectorProps,
}: DriverScreenWithOptionsPropsType<T>) => {
  return (
    <DriverStepScreenWrapper
      jobId={jobId}
      serviceId={serviceId}
      taskId={taskId}
      title={title}
      {...bottomButtonProps}>
      <DriverTaskOptionsSelector {...optionsSelectorProps} />
    </DriverStepScreenWrapper>
  );
};

export { DriverScreenWithOptions };
